import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
const Activities = () => {
  useEffect(() => {
    document.title = "Activities-  St Peters convent School Faridabad Haryana";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> About Us </li>
          <li>Activities </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Activities </h1>
            </div>
          </div>
          <div class="row facilities">
            <div class="col-12">
              <h3 class="subhead">Arts And Crafts Club</h3>
              <div class="facilities-img1 left-block">
                <LazyLoad>
                  <img
                    class="img-fluid"
                    src="https://webapi.entab.info/api/image/STPSFH/public/Images/Artsimg.jpg"
                    alt="STPCSH"
                  />
                </LazyLoad>{" "}
              </div>{" "}
              <p class="first-letter">
                {" "}
                This club was formed with the idea of moulding the students to
                have interest in colours, craft etc. We have classes for fabric
                painting, glass painting, oil painting, pencil drawing, pottery
                painting etc. We provide our students with expert teachers as
                they could make them better than the best.
              </p>
            </div>
            <hr />
            <div class="col-12">
              <h3 class="subhead">Sports Club</h3>
              <div class="facilities-img right-block">
                <LazyLoad>
                  <img
                    class="img-fluid"
                    src="https://webapi.entab.info/api/image/STPSFH/public/Images/Sportsimg.jpg"
                    alt="STPCSH"
                  />
                </LazyLoad>
              </div>
              <p class="first-letter">
                {" "}
                SPCS has provided certain refreshing following activities for
                the students to relieve them out of their stress and strain.
                Indoor games : Chess, Table tennis, Carrom board game etc.
                Outdoor games : Volleyball, Football, Badminton, Kho Kho,
                Athletics etc. Others : Abacus and Vedic maths.
              </p>
              <br />
            </div>
            <hr />
            <div class="col-12">
              <h3 class="subhead">House wise Programmes </h3>
              <div class="facilities-img1 left-block">
                <LazyLoad>
                  <img
                    class="img-fluid"
                    src="https://webapi.entab.info/api/image/STPSFH/public/Images/competitionsimg.jpg"
                    alt="STPCSH"
                  />
                </LazyLoad>
              </div>
              <p class="first-letter">
                All the students are divided into four houses. 1. Emerald
                (Green) 2.Topaz (Yellow) 3.Ruby (Red) 4.Sapphire (Blue) The
                competitions in the school are being done house wise. The
                responsibility of conducting different celebrations is also been
                given to different houses. This will develop a sense of unity,
                competitive spirit and responsibility among students.
              </p>
              <br />
            </div>
            <hr />
            <div class="col-12">
              <h3 class="subhead">Speakers Forum </h3>
              <div class="facilities-img right-block">
                <LazyLoad>
                  <img
                    class="img-fluid"
                    src="https://webapi.entab.info/api/image/STPSFH/public/Images/SpeakersForumimg.jpg"
                    alt="STPCSH"
                  />
                </LazyLoad>
              </div>
              <p class="first-letter">
                {" "}
                This forum assist the students for extempore and in sharing
                their ideas spontaneously in different ways and languages.
              </p>
              <br />
            </div>
            <hr />
            {/* <div class="col-12">
              <h3 class="subhead">Quiz Club</h3>
              <div class="facilities-img1 left-block">
                <LazyLoad>
                  <img
                    class="img-fluid"
                    src="https://webapi.entab.info/api/image/STPSFH/public/Images/QuizClubimg.jpg"
                    alt="STPCSH"
                  />{" "}
                </LazyLoad>
              </div>
              <p class="first-letter">
                This club helps the students to enhance and test their
                comprehension in various fields like General knowledge, current
                affairs etc. House wise competitions are being conducted as part
                of this.
              </p>
              <br />
            </div> */}
            {/* <hr /> */}
            <div class="col-12">
              <h3 class="subhead">Karate, Yoga </h3>
              <div class="facilities-img right-block">
                <LazyLoad>
                  <img
                    class="img-fluid"
                    src="https://webapi.entab.info/api/image/STPSFH/public/Images/Karateimg.jpg"
                    alt="STPCSH"
                  />{" "}
                </LazyLoad>
              </div>
              <p class="first-letter">
                {" "}
                Yoga has been declared a part of UNESCO’s World Heritage.Yoga
                demands that the practitioner concentrate and focus on what
                their body is telling them – to notice their breathing pattern,
                concentrate on any aches and pains they might feel and calm the
                mind to simply concentrate on themselves.To equip the students
                in self-defense Karate classes will be helpful. The students
                will be acquiring these skills through well- trained
                instructors.{" "}
              </p>
              <br />
            </div>
            <hr />
            <div class="col-12">
              <h3 class="subhead"> Nature Club </h3>
              <div class="facilities-img1 left-block">
                <LazyLoad>
                  <img
                    class="img-fluid"
                    src="https://webapi.entab.info/api/image/STPSFH/public/Images/NatureClubimg.jpg"
                    alt="STPCSH"
                  />{" "}
                </LazyLoad>
              </div>
              <p class="first-letter">
                {" "}
                Nature is our Mother .It is our duty to love and care our Mother
                Earth. Club members are so interested in cleaning and greening
                campus programmes.{" "}
              </p>
              <br />
            </div>
            <hr />
            <div class="col-12">
              <h3 class="subhead">School Band </h3>
              <div class="facilities-img right-block">
                <LazyLoad>
                  <img
                    class="img-fluid"
                    src="https://webapi.entab.info/api/image/STPSFH/public/Images/BandSetimg.jpg"
                    alt="STPCSH"
                  />
                </LazyLoad>
              </div>
              <p class="first-letter">
                {" "}
                SPCS always aims at the overall development of a child. As a
                part of the co-curricular activities we have a band team of 33
                students under the training of the band master.
              </p>
              <br />
            </div>
            <hr />
            {/* <div class="col-12">
              <h3 class="subhead">Social Science, Math’s, IT Clubs </h3>
              <div class="facilities-img1 left-block">
                <LazyLoad>
                  <img
                    class="img-fluid"
                    src="https://webapi.entab.info/api/image/STPSFH/public/Images/SocialScienceimg.jpg"
                    alt="STPCSH"
                  />
                </LazyLoad>
              </div>
              <p class="first-letter">
                {" "}
                Under the guidance of these subject teachers children are doing
                some activities for the betterment of school and community.
              </p>
              <br />
            </div>
            <hr /> */}
            <div class="col-12">
              <h3 class="subhead">Dance and Music Clubs</h3>
              <div class="facilities-img1 right-block">
                <LazyLoad>
                  <img
                    class="img-fluid"
                    src="https://webapi.entab.info/api/image/STPSFH/public/Images/MusicClubsimg.jpg"
                    alt="STPCSH"
                  />
                </LazyLoad>
              </div>
              <p class="first-letter">
                It helps the students to improve their aesthetic intelligence.
              </p>
              <br />{" "}
            </div>
            <hr />
            <div class="col-12">
              <h3 class="subhead">Robotics</h3>
              {/* <div class="facilities-img1 right-block">
                {/* <LazyLoad>
                  <img
                    class="img-fluid"
                    src="https://webapi.entab.info/api/image/STPSFH/public/Images/MusicClubsimg.jpg"
                    alt="STPCSH"
                  />
                </LazyLoad> */}
            </div>
            {/* <p class="first-letter">
              It helps the students to improve their aesthetic intelligence.
            </p> */}
            <br /> {/* </div> */}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Activities;
